import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, isDevMode, provideEnvironmentInitializer, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrConfig } from './shared/consts/configs.const';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { initAnalytics } from './core/initializers/analytics.initializer';
import { initProUser } from './core/initializers/pro-user.initializer';
import { JobsScrollRestorationService } from './core/services/scroll/jobs-scroll-restoration.service';
import { initIp } from './core/initializers/ip.initializer';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { environment } from '../environments/environment';
import { tokenInterceptor } from './core/services/interceptors/token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'disabled'
      })
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor]),
      withInterceptorsFromDi(),
       // Enables DI-based interceptors
    ),
    provideClientHydration(withEventReplay()),
    provideToastr(ToastrConfig),
    provideAnimationsAsync(),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) :string => {
        const path = config.src.startsWith('/') ? config.src.substring(1) : config.src;
        return `${environment.bucketAssetUrl}/${path}`;
      }
    },
    
    // { provide: HTTP_INTERCEPTORS, useClass: HTTPInterceptor, multi: true },
    provideTransloco({
      config: {
        availableLangs: ['en', 'bn'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          logMissingKey: false, // Disable logging under high load
        }
      },
      loader: TranslocoHttpLoader
    }),
    provideEnvironmentInitializer(initAnalytics),
    provideEnvironmentInitializer(initProUser),
    provideEnvironmentInitializer(initIp),
    provideEnvironmentInitializer(() => inject(JobsScrollRestorationService).init()),
  ],
};
